import { useEffect, useState } from "react";
import { toast } from "sonner";
import { ShieldAlert } from "lucide-react";

// Protections best-effort contre copie / impression / captures d'écran.
// NB : un navigateur ne peut pas bloquer à 100% une capture d'écran au niveau OS.
export default function ScreenGuard() {
  const [masked, setMasked] = useState(false);

  useEffect(() => {
    const prevent = (e) => e.preventDefault();
    const onKey = (e) => {
      if (e.key === "PrintScreen") {
        try { navigator.clipboard.writeText(""); } catch { /* ignore */ }
        toast.warning("Capture d'écran désactivée sur cette application.");
        setMasked(true);
        setTimeout(() => setMasked(false), 1200);
      }
      if ((e.ctrlKey || e.metaKey) && ["p", "s", "c"].includes((e.key || "").toLowerCase())) {
        // bloque impression / sauvegarde / copie clavier (hors champs de saisie)
        const tag = (e.target?.tagName || "").toLowerCase();
        if (e.key.toLowerCase() !== "c" || !["input", "textarea"].includes(tag)) e.preventDefault();
      }
    };
    // NB : on NE masque plus l'écran sur blur/focus/visibilitychange : dans les environnements
    // avec supervision / bureau à distance, ces événements peuvent se déclencher en boucle et
    // provoquaient un clignotement/tremblement plein écran.
    document.addEventListener("contextmenu", prevent);
    document.addEventListener("copy", prevent);
    document.addEventListener("cut", prevent);
    document.addEventListener("dragstart", prevent);
    document.addEventListener("keydown", onKey);
    document.addEventListener("keyup", onKey);
    return () => {
      document.removeEventListener("contextmenu", prevent);
      document.removeEventListener("copy", prevent);
      document.removeEventListener("cut", prevent);
      document.removeEventListener("dragstart", prevent);
      document.removeEventListener("keydown", onKey);
      document.removeEventListener("keyup", onKey);
    };
  }, []);

  if (!masked) return null;
  return (
    <div className="screen-guard-overlay" data-testid="screen-guard">
      <div className="text-center px-6">
        <ShieldAlert className="h-10 w-10 mx-auto mb-3 text-sky-400" />
        <p className="font-display font-bold text-lg">Contenu protégé</p>
        <p className="text-sm text-muted-foreground mt-1">Les captures et copies d'écran sont désactivées.</p>
      </div>
    </div>
  );
}
